// Cookie Consent utility for Volepse.me

/**
 * Cookie consent manager
 */
export const CookieConsent = {
  CONSENT_KEY: 'volepse_cookie_consent',
  GA_LOADED_KEY: 'volepse_ga_loaded',

  /**
   * Check if user has given consent
   * @returns {boolean|null} true if accepted, false if declined, null if not set
   */
  hasConsent() {
    const consent = localStorage.getItem(this.CONSENT_KEY);
    if (consent === null) return null;
    return consent === 'true';
  },

  /**
   * Set user consent
   * @param {boolean} consent
   */
  setConsent(consent) {
    localStorage.setItem(this.CONSENT_KEY, consent.toString());

    if (consent) {
      this.loadGoogleAnalytics();
    } else {
      this.disableGoogleAnalytics();
    }
  },

  /**
   * Load Google Analytics script dynamically
   */
  loadGoogleAnalytics() {
    if (typeof window === 'undefined') return;

    // Check if already loaded
    if (localStorage.getItem(this.GA_LOADED_KEY) === 'true') return;

    const GA_MEASUREMENT_ID = 'G-FXW0FGH0R4';

    // Create and append GA script
    const script = document.createElement('script');
    script.async = true;
    script.src = `https://www.googletagmanager.com/gtag/js?id=${GA_MEASUREMENT_ID}`;
    document.head.appendChild(script);

    // Initialize GA
    window.dataLayer = window.dataLayer || [];
    function gtag() {
      window.dataLayer.push(arguments);
    }
    window.gtag = gtag;

    gtag('js', new Date());
    gtag('config', GA_MEASUREMENT_ID, {
      page_path: window.location.pathname,
      send_page_view: true,
      anonymize_ip: true, // GDPR compliance
    });

    // Mark as loaded
    localStorage.setItem(this.GA_LOADED_KEY, 'true');

    console.log('Google Analytics loaded with user consent');
  },

  /**
   * Disable Google Analytics
   */
  disableGoogleAnalytics() {
    if (typeof window === 'undefined') return;

    const GA_MEASUREMENT_ID = 'G-FXW0FGH0R4';

    // Disable GA tracking
    window[`ga-disable-${GA_MEASUREMENT_ID}`] = true;

    // Clear GA cookies
    this.deleteCookie('_ga');
    this.deleteCookie('_gat');
    this.deleteCookie('_gid');

    // Remove loaded flag
    localStorage.removeItem(this.GA_LOADED_KEY);

    console.log('Google Analytics disabled');
  },

  /**
   * Delete a cookie
   * @param {string} name
   */
  deleteCookie(name) {
    document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`;
  },

  /**
   * Reset consent (for testing)
   */
  resetConsent() {
    localStorage.removeItem(this.CONSENT_KEY);
    localStorage.removeItem(this.GA_LOADED_KEY);
    this.disableGoogleAnalytics();
  }
};

